import { render, staticRenderFns } from "./proteksi_api.vue?vue&type=template&id=853d4062&"
import script from "./proteksi_api.vue?vue&type=script&lang=js&"
export * from "./proteksi_api.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports